import { render, staticRenderFns } from "./iconDownload.vue?vue&type=template&id=37557b72"
import script from "./iconDownload.vue?vue&type=script&lang=js"
export * from "./iconDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports